import { render, staticRenderFns } from "./Log.vue?vue&type=template&id=2c1099f5&scoped=true"
var script = {}
import style0 from "./Log.vue?vue&type=style&index=0&id=2c1099f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1099f5",
  null
  
)

export default component.exports